import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
// docs for vue-slider-component here: https://nightcatsama.github.io/vue-slider-component

export default {
  name: 'PriceFilter',
  components: {
    VueSlider,
  },
  props: ['filter', 'minPrice', 'maxPrice', 'initialPriceRange'],
  emits: ['open', 'price-change'],
  data() {
    return {
      sliderValue: 50,
      range: this.initialPriceRange,
    };
  },
  watch: {
    range: {
      handler: function (newRange) {
        this.$emit('price-change', newRange);
      },
    },
  },
  methods: {
    resetFilter() {
      this.range = [this.minPrice, this.maxPrice];
    },
  },
  mounted() {
    // emit price range in case range has been adjusted by url params
    this.$emit('price-change', this.range);
  },
};
